import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'
import { get } from 'lodash'
import { getRemoteVideo, userCheckMobileScreen } from 'helpers/tools'
import Image from 'components/atoms/Image'
import GridGallery from 'components/molecules/GridGallery/GridGallery'
import Banner from 'components/molecules/Banner/Banner'
import NavBarLandingPage from 'components/organisms/NavBarLandingPage'
import AccessibilityBar from '../AccessibilityBar'

import './BannerWithMosaicImages.scss'

function BannerWithMosaicImages({ data, refs }) {
  const isMobile = userCheckMobileScreen()
  const medias = get(data, 'medias')

  return (
    <>
      <AccessibilityBar refs={refs} />
      <NavBarLandingPage
        bgColor={get(data, 'background_color.color')}
        menu={get(data, 'menu')}
        logo={get(data, 'logo.entity.images.medium.url')}
        ref={refs ? refs.nav : null}
      />
      {(get(data, 'title') || get(data, 'description') || medias.length > 0) && (
        <Container
          style={{ backgroundColor: get(data, 'background_color.color') }}
          fluid
          className="banner-mosaic-images section-spacing"
        >
          <Container>
            <Row className="banner-mosaic-images__container">
              {isMobile && (
                <Col className="banner-mosaic-images__image--mobile">
                  {get(medias[0], 'entity.entityBundle') === 'remote_video' ? (
                    <iframe
                      src={getRemoteVideo(get(medias[0], 'entity.fieldMediaOembedVideo')).url}
                      className="mosaic-video"
                      scrolling="no"
                      frameBorder="0"
                      width="100%"
                      allowFullScreen
                    />
                  ) : (
                    <Image
                      className="mosaic-image"
                      src={get(medias[0], 'entity.images.wide.url')}
                      alt="Imagem ilustrativa"
                    />
                  )}
                </Col>
              )}
              <Col lg={5}>
                <Banner
                  className="banner-mosaic-images__content w-100 pt-lg-5 mt-lg-3"
                  title={get(data, 'title')}
                  theme={get(data, 'theme.entity.classes')}
                  link={{
                    url: get(data, 'button.entity.link.url.path'),
                    title: get(data, 'button.entity.link.title'),
                  }}
                >
                  {ReactHtmlParser(get(data, 'description.value'))}
                </Banner>
              </Col>
              {medias && (
                <Col lg={7}>
                  <GridGallery
                    items={medias.map(({ entity }) => ({
                      src: get(entity, 'images.wide.url'),
                      video: getRemoteVideo(get(entity, 'fieldMediaOembedVideo'))?.url,
                    }))}
                  />
                </Col>
              )}
            </Row>
          </Container>
        </Container>
      )}
    </>
  )
}

export default BannerWithMosaicImages
